export const themeColor = {
    PRIMARY: '#282e38',
    SECONDARY: '#CCCCCC',
}
